import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './ErrorBox.css';

const propTypes = {
    onClick: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    hide: PropTypes.bool,
    noTopMargin: PropTypes.bool,
    noBottomMargin: PropTypes.bool,
};

export class ErrorBox extends React.Component {
    static defaultProps = {
        onClick: undefined,
        hide: false,
        noTopMargin: false,
        noBottomMargin: false,
    };

    render() {
        return (
            <div
                onClick={this.props.onClick}
                className={classNames(s.box, {
                    [s.hide]: this.props.hide,
                    [s.noMarginOnTop]: this.props.noTopMargin,
                    [s.noMarginOnBottom]: this.props.noBottomMargin,
                    [s.clickable]: this.props.onClick,
                })}
            >
                {typeof this.props.label === 'string' ? (
                    <p>{this.props.label}</p>
                ) : (
                    this.props.label.map((l, i) => <p key={i}>{l}</p>)
                )}
            </div>
        );
    }
}

ErrorBox.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/text/ErrorBox.jsx